<template>
  <PainelLayout>
    <Breadcrumb :lista="[
      { 'name':'Painel', 'link' : '/' }]"
    />

    <div class="row">
      <div class="col-6">
        <h1>Usuários</h1>
      </div>
      <div class="col-6 text-end">
        <router-link to="/users/new">
          <button class="btn btn-primary mt-3">Novo usuário</button>
        </router-link>
      </div>
    </div>
    <hr/>

    <app-table v-if="!loading" empty-message='nada encontrado'
    :colunas="[{ label: 'Nome' }, { label: 'Email' }, {label: 'Nivel'}, { label: ''}]">
      <app-trow
        v-for="item in lista" :key="item.id"
        :data="[
          {value: item.name},
          {value: item.email},
          {value: levelFormat.level(item.pivot.rule)}
        ]"
      >
      <template #actions>
        <router-link class="btn btn-sm btn-primary me-2" :to="{ path: '/users/new', query: { edit: true, id: item.id } }">
          <i class="bi bi-pencil-fill"></i>
        </router-link>
      </template>
      </app-trow>
    </app-table>
    <div v-else class="d-flex justify-content-center p-3">
      <div class="spinner-border" style="width: 4rem; height: 4rem;" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    
  </PainelLayout>
</template>

<script>
import PainelLayout from '@/layouts/PainelLayout.vue';
import { onMounted, ref, reactive } from 'vue';
import { Modal } from 'bootstrap';
import Breadcrumb from '@/components/itens/breadcrumb.vue';
import { users } from '@/models/users';
import { useToastStore } from '@/stores/toastStore';
import { parseError } from '@/utils/errorHelper';
import AppTable from '@/components/AppTable.vue';
import AppTrow from '@/components/AppTrow.vue';
import levelFormat from '@/services/levelFormat';

export default {
  name: "UsersView",
  components: {
    PainelLayout,
    Breadcrumb, AppTable, AppTrow
  },
  setup(props) {

    const toastStore = useToastStore();
    const lista = ref([]);
    const loading = ref(false);
    const model = users();

    let modal = '';
    var advancedMode = ref(false);
    const userobj = reactive({
      id: null,
      name: ''
    });

    function openModal(elemento) {
      const modalObj = document.getElementById(elemento);
      modal = new Modal(modalObj);
      modal.show();
    };

    function closeModal() {
      modal.hide();
    };

    function showModal_delete(item) {
      userobj.id = item.id;
      userobj.name = item.name;
      openModal('modal_delete');
    }

    function confirmExcluir() {
      model.delet(userobj.id).then(() => {
        toastStore.success('Usuário excluído com sucesso.');
        closeModal();
        list();
      }).catch((error) => {
        toastStore.error('Erro ao excluir usuário: ' + parseError(error));
      });
    }

    async function list() {
      loading.value = true;
      try {
        lista.value = await model.list();
      } catch (error) {
        toastStore.addToast('Erro ao listar usuários', 'danger');
      } finally {
        loading.value = false;
      }
    }

    onMounted(() => {
      list();
    });

    return {
      lista,
      userobj,
      advancedMode,
      loading,
      closeModal,
      openModal,
      showModal_delete,
      confirmExcluir,
      levelFormat
    }
  }
}
</script>